import Vue from 'vue'
import App from './App.vue'
import '../globals.css'
import router from './router'
import vuetify from './plugins/vuetify'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueMobileDetection from 'vue-mobile-detection'

Vue.config.productionTip = false

Vue.use(VueAxios, axios);
Vue.use(VueMobileDetection);

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
